import Sticky from '../components/sticky';
import moment from 'moment';
import DatePickerPikaday from '../components/datepicker-pikaday';
import CustomSelect from '../components/custom-select';
import { View, Utils } from '../vendor/kerneljs';

let indexOrigin = 0;

const ParkingBooking = View.extend({
	events: {
		'click .js--book': 'testTimePicker'
	},
	initialize: function (el) {
		let dateTimePairElems = this.find('.js--date-time-pair');

		this.dateTimePair1 = new ParkingDateTimePair({ el: dateTimePairElems[0], index: 0 + indexOrigin, dateUpdateEvent: 'date1:chosen' });
		this.dateTimePair2 = new ParkingDateTimePair({ el: dateTimePairElems[1], index: 1 + indexOrigin, dateUpdateEvent: 'date2:chosen' });

		indexOrigin += 10;

		this.dateTimePair1.setMinDate(new Date());
		this.dateTimePair2.setMinDate(new Date());

		this.dateTimePair1.linkWith(this.dateTimePair2, true);
		this.dateTimePair2.linkWith(this.dateTimePair1);

		document.addEventListener('date1:chosen', this.startDateUpdate.bind(this));
		document.addEventListener('date2:chosen', this.endDateUpdate.bind(this));

		this.campaignCode = this.el.querySelector('.js--campaign-code');
		if (this.campaignCode){
			this.campaignCodeApplied = this.el.querySelector('.js--campaign-code-applied');
			this.campaignCode.querySelector('button')?.addEventListener('click', this.handleApplyCode.bind(this));
		}
		this.parkingForm = this.el.querySelector('.js--parking-form');
		this.parkingPreviewMobile = this.el.querySelector('.js--parking-preview');
		this.togglePreviewMobile = this.el.querySelectorAll('.js--toggle-parking-form');
		this.mobileCampaignCodeButton = this.el.querySelector('.mobile-campaign-btn');

		this.togglePreviewMobile.forEach(function(element) {
			element.addEventListener('click', this.handleTogglePreviewMobile.bind(this));
		}, this);

		this.wrapper = document.querySelector('.parking-time-picker-wrapper');
		new Sticky( {el: this.wrapper} );
	},

	handleApplyCode: function () {
		this.campaignCodeApplied.classList.add('show');
		this.campaignCode.classList.remove('show');
	},

	handleTogglePreviewMobile: function () {
		this.parkingForm.classList.toggle('show');
		this.parkingPreviewMobile.classList.toggle('hide');
		this.mobileCampaignCodeButton.classList.toggle('hide');
	},



	testTimePicker: function () {
		setTimeout(function () {
			if (this.dateTimePair1.getTimeValue() === "") {
				this.dateTimePair1.forceOpenTime();
			}
			else if (this.dateTimePair2.getTimeValue() === "") {
				this.dateTimePair2.forceOpenTime();
			}
			else {
				window.location.href = window.location.href.split('?')[0] + '?ad=01%2F12%2F2016&at=06%3A00&dd=07%2F12%2F2016&dt=18%3A00';
			}
		}.bind(this), 100);
	},

	startDateUpdate: function (event) {
		let date = event.detail.date;

		this.dateTimePair1.setDateRangeStart(date);
		this.dateTimePair2.setDateRangeStart(date);
	},
	endDateUpdate: function (event) {
		let date = event.detail.date;

		this.dateTimePair1.setDateRangeEnd(date);
		this.dateTimePair2.setDateRangeEnd(date);
	}
});

const ParkingDateTimePair = View.extend({
	events: {
		'focus .js--date': 'dateFocus',
		'blur .js--date': 'dateBlur'
	},
	linkWith: function (dateTimePair, activateLinkedPair) {
		this.linkedPair = dateTimePair;
		this.activateLinkedPair = activateLinkedPair || false;
	},
	initialize: function () {
		this.dateFormField = this.find('.js--date-form-field');
		this.dateControl = this.find('.js--date');
		this.dateVal = this.dateControl.getAttribute('value');

		this.dateUpdateEvent = this.settings.dateUpdateEvent;

		this.timeFormField = this.find('.js--time-form-field');
		this.timeControl = this.find('.js--time');

		this.datePicker = new DatePickerPikaday({ container: this.dateFormField, el: this.dateFormField, index: this.settings.index });
		this.customSelect = new CustomSelect({ el: this.timeFormField, index: this.settings.index });


		setTimeout(function () {
			this.eventEmitter.on('datepicker:change', this.dateChangeHandler.bind(this));
			this.eventEmitter.on('customselect:change', this.timeChangeHandler.bind(this));
		}.bind(this), 500);
	},

	activate: function () {
		let m = moment(this.getDateValue());
		if (!m.isValid()) { //Open only if it's not already a valid date
			this.datePicker.show();
		}
	},

	resolveDate: function (val) {
		if (!val) { return }
		return moment().add(val, 'days')._d;
	},

	dateChangeHandler: function (index) {
		if (index !== this.settings.index) return false;
		
		this.dateVal = this.dateControl.getAttribute('value');
		Utils.addClass(this.dateFormField, 'is-filled');
		let dateObject = this.datePicker.getPicker().getDate();
		document.dispatchEvent(new CustomEvent(this.dateUpdateEvent, { detail: { date: dateObject } }));

		if (!this.customSelect.valueChosen) this.forceOpenTime();
	},

	dateFocus: function () {
		if (Utils.hasClass(this.dateControl, 'is-disabled')) return;
		Utils.addClass(this.dateControl, 'has-focus');
		Utils.addClass(this.dateControl, 'is-filled');
	},

	dateBlur: function () {
		// nothing
	},
	forceOpenTime: function () {
		this.timeFormField.dispatchEvent(new Event('customselect:focus'));
	},

	timeChangeHandler: function (index) {
		if (index !== this.settings.index) return false;

		Utils.addClass(this.timeFormField, 'is-filled');
		if (this.linkedPair && this.activateLinkedPair) this.linkedPair.activate();
	},

	getTimeValue: function () {
		return this.timeControl.value;
	},

	getDateValue: function () {
		return moment(this.dateControl.value, 'DD / MM / YYYY')._d
	},

	setMinDate: function (date) {
		if (!this.getPicker()) return;
		this.getPicker().setMinDate(date);
	},
	setMaxDate: function (date) {
		if (!this.getPicker()) return;
		this.getPicker().setMaxDate(date);
	},
	setDateRangeStart: function (date) {
		if (!this.getPicker()) return;
		this.getPicker().setStartRange(date);
	},
	setDateRangeEnd: function (date) {
		if (!this.getPicker()) return;
		this.getPicker().setEndRange(date);
	},
	gotoDate: function (date) {
		if (!this.getPicker()) return;
		this.getPicker().gotoDate(date);
	},

	getPicker: function () {
		if (!this.datePicker) return false;

		if (!this.datePicker.getPicker()) return false;

		return this.datePicker.getPicker();
	}
});


(function () {
	Utils.each(Utils.find('.js--parking-time-picker'), function (elem) {
		new ParkingBooking({ el: elem });
	});
})();

export default ParkingBooking;
